import _ from "lodash";
import React from "react";
import classes from "./CommentItem.scss";
import ProfileCascade from "UIComponents/ProfileCascade";
import UIButton from "UIComponents/UIButton";
import TaggableInputField from "UIComponents/TaggableInputField";
import I18nHOC from "UIComponents/I18nHOC";
import AudioRecorderSelector from "UIComponents/AudioRecorderSelector";
import Unveil from "UIComponents/Unveil";
import classNames from "classnames";
import { AttachmentList } from "Attachment";
import {
  getTimeSince,
  getCommentDisplayContent,
  getStyleStrippedText,
} from "Utils";
import { ReplyIconSvg } from "SvgComponents";
import { colors } from "Constants";
import {
  MicrophoneOutlined,
  DotsHorizontalOutlined,
} from "@toddle-edu/ds-icons";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import { Dropdown, IconButton, DropdownMenu } from "@toddle-edu/ds-web";
import {
  getFormattedUserName,
  getUserIdentifierName,
} from "Utils/GetFormattedUserName";

const defaultStyles = {
  profileCascadeStyle: {
    borderWidth: 0,
    width: 40,
    height: 40,
  },
};

const MENU_ITEMS = t => [
  {
    label: t("edit"),
    disabled: false,
    id: "EDIT",
    key: "EDIT",
  },
  {
    label: t("delete"),
    disabled: false,
    id: "DELETE",
    key: "DELETE",
  },
];

class CommentItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { showDropDown: false, uploadStatus: false };
  }

  renderMenuItem = t => {
    const {
      userInfo: { id: user_id, user_type },
      item: {
        createdBy: { id, type },
      },
      deleteOtherComment,
    } = this.props;

    if (id == user_id) {
      return MENU_ITEMS(t);
    } else if (user_type == "staff" && type != "staff" && deleteOtherComment) {
      return _.filter(MENU_ITEMS(t), item => {
        return item.id != "EDIT";
      });
    }

    return [];
  };

  clickAction = action => {
    const { onClickDelete, onClickEdit } = this.props;
    switch (action) {
      case "EDIT":
        onClickEdit();
        break;
      case "DELETE":
        onClickDelete();
        break;
      default:
        break;
    }
  };

  render() {
    const {
      item,
      customItemRef,
      userInfo,
      isEditing,
      label,
      attachments,
      onCommentDataChange,
      onCommentEdit,
      onCancelEdit,
      collaborators,
      onCommentInputRef,
      parentNode,
      disableTagging,
      commentItemContainerStyle,
      commentItemStyle = {},
      itemId,
      t,
      allowReply,
      showMessageBox,
      nagivateToProfile,
      canCreateAudioComment,
      unveilMaxHeight,
      shouldCollapseMessage,
      isRightPaneChat,
      mode,
      uploadFileType,
      testId,
    } = this.props;

    const { id: user_id } = userInfo;
    const { showDropDown, isCommentLoading, uploadStatus } = this.state;
    const { createdAt, createdBy } = item;
    const { profileImage, id, schoolTenures } = createdBy;
    const enableDropDown = user_id == id && showDropDown;
    const schoolName = _.get(schoolTenures, "0.school.name");

    const moreContainerStyle = classNames(
      { [classes.moreContainer]: true },
      { [classes.visible]: enableDropDown }
    );

    const timeTextContainerStyle = classNames(
      { [classes.timeText]: true }
      // { [classes.hidden]: enableDropDown }
    );

    const containerStyle = classNames(
      { [classes.normalcontainer]: !isEditing },
      { [classes.editCotainer]: isEditing }
    );
    const textAreaStyle = classNames({
      [classes.messageText]: true,
      [classes.editMessageText]: isEditing,
    });

    const nameTextClasses = classNames({
      [classes.nameText]: true,
      [classes.underlineOnHover]: nagivateToProfile,
    });

    const menuItems = this.renderMenuItem(t);
    const characterLimit = 8000 - label?.length;

    const userIdentifierName = getUserIdentifierName({ user: createdBy });
    const userFormattedName = getFormattedUserName({ user: createdBy });

    const ButtonComponent = ({ uploadFileType, uploadStatus }) => {
      return (
        <MicrophoneOutlined
          variant={"link"}
          size={"x-small"}
          disabled={uploadStatus && _.isEqual(uploadFileType, "AUDIO")}
        />
      );
    };

    const onMenuItemClick = ({ key }) => {
      this.clickAction(key);
    };

    return (
      <div
        style={commentItemContainerStyle}
        className={containerStyle}
        ref={ref => customItemRef(ref)}
      >
        <div className={classes.leftContainer}>
          <ProfileCascade
            items={[{ id, value: userIdentifierName, imageUrl: profileImage }]}
            customStyle={{
              ...defaultStyles.profileCascadeStyle,
              ...commentItemStyle.profileCascadeStyle,
            }}
          />
        </div>
        <div className={classes.rightContainer}>
          <div className={classes.headerContainer}>
            <div className={classes.headerContentWrapper}>
              <div className={classes.nameContainer}>
                <div
                  className={nameTextClasses}
                  data-test-id={`${testId}-commentItem-${itemId}-navigateToProfile-button`}
                  style={{ ...commentItemStyle.nameText }}
                  onClick={() => null}
                >
                  {userFormattedName}
                </div>

                <div
                  className={timeTextContainerStyle}
                  style={{ ...commentItemStyle.timeTextContainerStyle }}
                >
                  <span className={classes.dot}>{`•`}</span>
                  {getTimeSince(new Date(createdAt), t)}
                </div>
              </div>

              {nagivateToProfile && (
                <div
                  className={classes.schoolName}
                  style={{ ...commentItemStyle.schoolName }}
                >
                  {schoolName}
                </div>
              )}
            </div>

            {!isEditing && mode == "edit" && (
              <div
                className={moreContainerStyle}
                style={commentItemStyle.moreContainer}
              >
                {_.get(menuItems, "length", 0) > 0 ? (
                  <Dropdown
                    disabled={_.includes(itemId, "NEW")}
                    overlay={
                      <DropdownMenu
                        testId={`${testId}-commentItem-${itemId}-actionMenu`}
                        options={menuItems}
                        onClick={onMenuItemClick}
                      ></DropdownMenu>
                    }
                  >
                    <IconButton
                      testId={`${testId}-commentItem-${itemId}-actionMenu`}
                      _legacy_variant={"subtle"}
                      variant="neutral"
                      type="plain"
                      _legacy_size="xx-small"
                      size="small"
                      icon={<DotsHorizontalOutlined variant="subtle" />}
                    ></IconButton>
                  </Dropdown>
                ) : null}
              </div>
            )}
          </div>
          {isCommentLoading ? (
            <div className={classes.loadingAnimationContainer}>
              <div className={classes.loadingAnimation} />
            </div>
          ) : isEditing ? (
            <div
              style={{
                flexDirection: "column",
                display: "flex",
                ...commentItemStyle.messageContainer,
              }}
            >
              <div
                className={classes.commentBoxOuterWrapper}
                ref={ref => (this.commentContainerRef = ref)}
              >
                <div className={classes.commentBoxInnerWrapper}>
                  <div className={classes.commentAudioBtnWrapper}>
                    <TaggableInputField
                      name={"label"}
                      commentContainerRef={this.commentContainerRef}
                      value={label}
                      updateInputField={onCommentDataChange}
                      userInfo={userInfo}
                      collaborators={collaborators}
                      ref={onCommentInputRef}
                      parentNode={parentNode}
                      disableTagging={disableTagging}
                      mentionInputConStyle={{ border: "none" }}
                      testId={`${testId}-commentItem-${itemId}`}
                    />
                    {canCreateAudioComment && (
                      <div className={classes.audioBtnWrapper}>
                        <AudioRecorderSelector
                          testId={`${testId}-commentItem-${itemId}`}
                          parentType={"MESSAGE"}
                          parentId={itemId}
                          showValue={false}
                          header={t("common:voice_and_record")}
                          updateInputField={param => {
                            onCommentDataChange({
                              attachments: [...attachments, param],
                            });
                          }}
                          buttonComponent={
                            <ButtonComponent
                              uploadFileType={uploadFileType}
                              uploadStatus={this.state.uploadStatus}
                            />
                          }
                          uploadStatus={value =>
                            this.setState({ uploadStatus: value })
                          }
                          disabled={
                            this.state.uploadStatus && uploadFileType == "AUDIO"
                          }
                        />
                      </div>
                    )}
                  </div>
                  <AttachmentList
                    value={attachments}
                    name={"attachments"}
                    cardType={"vertical"}
                    showCreateDropdown={false}
                    updateInputField={onCommentDataChange}
                    parentId={itemId}
                    parentType={"MESSAGE"}
                    clubbingCards={2}
                    showSingleCardTheme={true}
                    cardStyle={{ height: 80 }}
                    attachmentContainerStyle={{
                      gridTemplateColumns: isRightPaneChat
                        ? "repeat(1,1fr)"
                        : _.get(attachments, "length", 0) > 1
                        ? "repeat(auto-fill, minmax(88px, 1fr))"
                        : "repeat(1,1fr)",
                      gridGap: "12px",
                    }}
                    containerStyle={{ padding: "0 8px 16px" }}
                    isRightPaneChat={isRightPaneChat}
                  />
                </div>
                {characterLimit < 0 ? (
                  <div className={classes.exceedCharacterCountContainer}>
                    {characterLimit}
                  </div>
                ) : null}
              </div>
              <div className={classes.buttonsCotainer}>
                <div
                  data-test-id={`${testId}-commentItem-${itemId}-cancel-button`}
                  className={classes.cancelButton}
                  onClick={onCancelEdit}
                >
                  {t("common:cancel")}
                </div>
                <UIButton
                  type="filled"
                  size="sm"
                  color="pink"
                  onClick={onCommentEdit}
                  isDisabled={uploadStatus || characterLimit < 0}
                  data-test-id={`${testId}-commentItem-${itemId}-save-button`}
                >
                  {t("common:save_changes")}
                </UIButton>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                minHeight: "40px",
                ...commentItemStyle.messageContainer,
              }}
            >
              <div className={classes.textAttachmentsCon}>
                <Unveil
                  maxHeight={unveilMaxHeight}
                  showCollapse={true}
                  collapsed={
                    String(itemId).startsWith("NEW_")
                      ? false
                      : shouldCollapseMessage
                  }
                >
                  <div
                    className={classes.textContainer}
                    style={{ ...commentItemStyle.textContainer }}
                    dangerouslySetInnerHTML={{
                      __html: getStyleStrippedText({
                        text: getCommentDisplayContent(label),
                        type: "SANITIZE_DANGER_HTML_PARAGRAPH",
                      }),
                    }}
                  />
                </Unveil>
                <AttachmentList
                  value={attachments}
                  cardType={"vertical"}
                  mode={"view"}
                  cardStyle={{ height: 80 }}
                  attachmentContainerStyle={{
                    gridTemplateColumns: isRightPaneChat
                      ? "repeat(1,1fr)"
                      : _.get(attachments, "length", 0) > 1
                      ? "repeat(auto-fill, minmax(88px, 1fr))"
                      : "repeat(1,1fr)",
                    gridGap: "12px",
                    marginTop: "4px",
                    position: "relative",
                  }}
                  clubbingCards={2}
                  showSingleCardTheme={true}
                  isRightPaneChat={isRightPaneChat}
                />
              </div>
            </div>
          )}
          {allowReply && (
            <div
              className={classes.replyContainer}
              data-test-id={`${testId}-commentItem-${itemId}-reply-button`}
              style={{ ...commentItemStyle.replyContainer }}
            >
              <div
                className={classes.replyButtonContainer}
                onClick={() => showMessageBox(createdBy)}
              >
                <ReplyIconSvg fill={colors.neutral400} width={10} height={10} />
                <div className={classes.replyButtonText}>
                  {t("community:reply")}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

CommentItem.defaultProps = {
  allowReply: false,
  nagivateToProfile: false,
  testId: "appComponents",
};

const mapStateToProps = (state, ownProps) => {
  const progressOfUploads = state.app_services.progressOfUploads;
  const uploadFileType = _.get(
    _.values(progressOfUploads)[0],
    "attachment.type",
    ""
  );
  return {
    uploadFileType,
  };
};

export default compose(
  connect(mapStateToProps, null),
  I18nHOC({ resource: "common" })
)(CommentItem);
